import { c as _c } from "react/compiler-runtime";
import { type PostFeedInput } from '@shared/all/validators';
import groupByFactiiiId from '@shared/utils/helpers/groupByFactiiiId';
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import useLocalPreference from '@shared/utils/hooks/useLocalPreference';
import usePostsShared from '@shared/utils/hooks/usePosts';
import useUser from '@shared/utils/hooks/useUser';
import { useInfiniteQuery } from '@tanstack/react-query';
import { client } from '../../utils/trpc';
import DataItem from './DataItem';
type Props = {
  params: PostFeedInput;
  uniqueId?: string;
};
const DataMode = props => {
  const $ = _c(19);
  const {
    localPreferenceState,
    getPostParams
  } = useLocalPreference();
  const {
    currentUser
  } = useUser();
  const {
    queryKey,
    fetchPrivatePosts
  } = usePostsShared(client, props.uniqueId);
  const isPrivateMode = localPreferenceState.postModeType === "private";
  let t0;
  if ($[0] !== fetchPrivatePosts || $[1] !== getPostParams || $[2] !== isPrivateMode || $[3] !== props.params) {
    t0 = async t1 => {
      const {
        pageParam
      } = t1;
      if (isPrivateMode) {
        const page = typeof pageParam === "number" ? pageParam : 0;
        const result = await fetchPrivatePosts({
          page
        });
        return {
          posts: result.posts,
          isPrivate: true
        };
      }
      const {
        posts
      } = await unwrapFromResult(client.posts.feed.query(getPostParams(props.params, pageParam, [])));
      const hasMore = posts.length > 1;
      const nextTimestamp = hasMore ? new Date(posts[posts.length - 1].createdAt).getTime() : undefined;
      if (hasMore) {
        posts.pop();
      }
      return {
        posts,
        isPrivate: false,
        nextTimestamp
      };
    };
    $[0] = fetchPrivatePosts;
    $[1] = getPostParams;
    $[2] = isPrivateMode;
    $[3] = props.params;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== isPrivateMode) {
    t1 = isPrivateMode ? 0 : Date.now();
    $[5] = isPrivateMode;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = currentUser.isAuthenticated !== null;
  let t3;
  if ($[7] !== queryKey || $[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t3 = {
      queryKey,
      queryFn: t0,
      initialPageParam: t1,
      getNextPageParam: _temp,
      refetchOnWindowFocus: false,
      enabled: t2
    };
    $[7] = queryKey;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const {
    data
  } = useInfiniteQuery(t3);
  if (!data) {
    return null;
  }
  const pagesForGrouping = data.pages;
  let t4;
  if ($[12] !== pagesForGrouping || $[13] !== props.params) {
    let t5;
    if ($[15] !== props.params) {
      t5 = (dataFactiiiGroup, i) => <DataItem key={i} initialFactiiiData={dataFactiiiGroup} params={props.params} />;
      $[15] = props.params;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = groupByFactiiiId(pagesForGrouping).map(t5);
    $[12] = pagesForGrouping;
    $[13] = props.params;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <div className="mt-4 space-y-4">{t4}</div>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default DataMode;
function _temp(lastPage, _allPages, lastPageParam) {
  const posts_0 = lastPage?.posts ?? [];
  if (posts_0.length === 0) {
    return;
  }
  if (lastPage.isPrivate) {
    if (posts_0.length < 10) {
      return;
    }
    return (lastPageParam as number) + 1;
  }
  return lastPage.nextTimestamp;
}